import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MiscService } from 'app/shared/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { DashboardService } from '../dashboard.service';
import * as dashboardActions from './dashboard.actions'

@Injectable({
    providedIn: 'root'
})

export class DashboardEffects {
    constructor(
        private actions$: Actions,
        private dashboardService: DashboardService,
        private toastr: ToastrService,
        private miscService: MiscService
    ) {}

    fetchOutstandingBalance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(dashboardActions.fetchOutstandingBalance),
      exhaustMap((action) =>
        this.dashboardService
          .getOutstandingBalance()
          .pipe(
            exhaustMap((response: any) => [
                dashboardActions.fetchOutstandingBalanceSuccess({ outstandingBalance: response.data[0] }),
            ]),
            catchError((error: HttpErrorResponse) => {
                this.toastr.error(error.error?.errors, 'An error occured');
                return of(dashboardActions.fetchOutstandingBalanceFailed())
            }
            )
          )
      )
    )
  );

fetchDasboardTransactionHistory$ = createEffect(() =>
  this.actions$.pipe(
    ofType(dashboardActions.fetchTransactionHistory),
    exhaustMap((action) =>
      this.dashboardService
        .getTransactionHistory(
          action.txnId, 
          action.status, 
          action.startDate, 
          action.endDate
        )
        .pipe(
          exhaustMap((response: any) => [
            dashboardActions.fetchTransactionHistorySuccess({ 
              transactionHistory: 
                action.status == '0' ? response.data.Success
                : action.status == '2' ? response.data['Partially Failed']
                : response.data['Failed']
            }),
          ]),
          catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occurred');
            return of(dashboardActions.fetchTransactionHistoryFailed())
          })
        )
    )
  )
);


  
fetchDasboardPendingTransactions$ = createEffect(() =>
  this.actions$.pipe(
    ofType(dashboardActions.fetchPendingTransactions),
    exhaustMap((action) =>
      this.dashboardService
        .getPendingTransactions(action.txnId, action.page, action.limit) // Added pagination parameters
        .pipe(
          exhaustMap((response: any) => [
            dashboardActions.fetchPendingTransactionsSuccess({ 
              pendingTransactions: response.data // Pass full data object to preserve pagination info
            }),
          ]),
          catchError((error: HttpErrorResponse) => {
            this.toastr.error(error.error?.errors, 'An error occured');
            return of(dashboardActions.fetchPendingTransactionsFailed())
          })
        )
    )
  )
);

  fetchPaymentChannels$ = createEffect(() =>
  this.actions$.pipe(
    ofType(dashboardActions.fetchPaymentChannels),
    exhaustMap((action) =>
      this.dashboardService
        .getMerchantPaymentChannels()
        .pipe(
          exhaustMap((response: any) => [
              dashboardActions.fetchPaymentChannelsSuccess({ paymentChannels: response.data }),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(dashboardActions.fetchPaymentChannelsFailed())
          }
          )
        )
    )
  )
);

  fetchChannelProducts$ = createEffect(() =>
  this.actions$.pipe(
    ofType(dashboardActions.fetchChannelProducts),
    exhaustMap((action) =>
      this.dashboardService
        .getChannelsProductsSummary(action.channelId)
        .pipe(
          exhaustMap((response: any) => [
              dashboardActions.fetchChannelProductsSuccess({ channelProducts: response.data }),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(dashboardActions.fetchChannelProductsFailed())
          }
          )
        )
    )
  )
);

  fetchProductEarning$ = createEffect(() =>
  this.actions$.pipe(
    ofType(dashboardActions.fetchProductEarning),
    exhaustMap((action) =>
      this.dashboardService
        .getMerchantEarningFromProductPerDay(action.channelId, action.productId)
        .pipe(
          exhaustMap((response: any) => [
              dashboardActions.fetchProductEarningSuccess({ productEarning: response.data }),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(dashboardActions.fetchProductEarningFailed())
          }
          )
        )
    )
  )
);

  fetchTransactionsPerday$ = createEffect(() =>
  this.actions$.pipe(
    ofType(dashboardActions.fetchTransactionsPerDay),
    exhaustMap((action) =>
      this.dashboardService
        .getTransactionsFromProductPerDay(action.productId, action.date)
        .pipe(
          exhaustMap((response: any) => [
              dashboardActions.fetchTransactionsPerDaySuccess({transactions: response.data }),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(dashboardActions.fetchTransactionsPerDayFailed())
          }
          )
        )
    )
  )
);
  fetchMTBtransactions$ = createEffect(() =>
  this.actions$.pipe(
    ofType(dashboardActions.fetchMTBtransactions),
    exhaustMap((action) =>
      this.dashboardService
        .getMoveToBanksTransactionsByStatus(action.status)
        .pipe(
          exhaustMap((response: any) => [
              dashboardActions.fetchMTBtransactionsSuccess({transactions: response.data }),
          ]),
          catchError((error: HttpErrorResponse) => {
              this.toastr.error(error.error?.errors, 'An error occured');
              return of(dashboardActions.fetchMTBtransactionsFailed())
          }
          )
        )
    )
  )
);


}